import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';
@Injectable({
  providedIn: 'root'
})

export class SbifService {
  // url = 'https://api.sbif.cl/api-sbifv3/recursos_api/';
  url = 'https://uf.agenciaeducacion.cl/api-sbifv3/recursos_api/';
  // url = 'https://stdag-desarrollo.agenciaeducacion.cl/srvc/98/';
  apikey = 'aad15e66be50c00b8fde4450597cc3ce8d3da2f3';
  format = 'json';

  constructor(private http: HttpClient, private _apiRestService: ApiRestService) { }

  public getCambio(date, opt): Observable<any> {
    date = date === '' ? null : new Date(date).toJSON().slice(0, 10).replace(/-/g, '/');
    // date = new Date(date).toJSON().slice(0, 10).replace(/-/g, '/');
    let year = new Date(date).getFullYear();
    let month = new Date(date).getMonth() + 1;
    let day = new Date(date).getDate();

    let apiURL = `${this.url}${opt}/${year}/${month}/dias/${day}/?apikey=${this.apikey}&formato=${this.format}`;
    // let apiURL = `${this.url}${year}/${month}/${day}/${opt}`;
    //  let apiURL = `${this._apiRestService.APIURL.serv98}/${year}/${month}/${day}/${opt}`;

    // Jsonp
    // let u = `${ this.url }${ opt }/${year}/${ month } /dias/${ day } /?apikey=${this.apikey}&formato=${this.format}&callback=${this.callback}`
    //   return this.http.jsonp(apiURL, 'callback')
    //   .pipe(
    //     map((data: Response) => {console.log(data.json() || {}); 
    //   return data.json()
    //   }),
    //     catchError(err => { return throwError(err) })
    //   );

    return this.http.get(apiURL).pipe(
      map((res: any) => {
        // if (!res.CodigoHTTP) {
        //   return res;
        // }
        // else {
        //   return res;
        //   // return throwError(new Error(res));
        // }
        return res;
      }));
  }
}
